<p-confirmDialog #cd header="{{'LABEL.CONFIRMATION' | translate}}"
                 [message]="message" [baseZIndex]="999999"
                 icon="pi pi-exclamation-triangle">
  <p-footer>
    <button pButton type="button" class="p-button-outlined p-button-secondary mr-2" icon="pi pi-times" label="{{'LABEL.NO' | translate}}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="{{'LABEL.YES' | translate}}" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
